import axios from '@/zenky'
import { isPhoneInvalid as isPhoneInvalidApiError } from '@/helpers/apiErrors';

/**
 * @param {string} phone - potentially invalid phone
 * @param {string} phone_country - phone country
 * @returns {null | { registered: boolean, confirmed: boolean }} null if could not check.
 */
export default async function (phone, phone_country) {
  const req = axios.post('/auth/check', {
    phone,
    phone_country,
  });
  try {
    return (await req).data.data;
  } catch (err) {
    if (isPhoneInvalidApiError(err)) {
      return null;
    }
    throw err;
  }
}
